import http from '@/util/http'
// 一周内即将转移公共的客户数量
export function queryByCount () {
  return http({
    url: '/api/customerBase/queryByCount',
    method: 'get'
  })
}
// 我的客户列表
export function queryAllCustomerLike (cusState, page, size, data) {
  return http({
    url: `/api/customerBase/queryAllCustomerLike/${cusState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 验证名称是否重复
export function queryByCusName (cusName) {
  return http({
    url: `/api/customerBase/queryByCusName/${cusName}`,
    method: 'get'
  })
}
// 添加客户
export function customerBaseAdd (data) {
  return http({
    url: '/api/customerBase/add',
    method: 'post',
    data: data
  })
}

//
export function queryBySusName (suName) {
  return http({
    url: `/api/orderManualInquiry/queryVerify/${suName}`,
    method: 'post'
  })
}

/// 快速添加客户
export function addFast (data) {
  return http({
    url: '/api/customerBase/addFast',
    method: 'post',
    data: data
  })
}
// 删除客户
export function customerBaseDelete (data, id) {
  return http({
    url: `/api/customerBase/delete/${id}`,
    method: 'post',
    data: data
  })
}
// 获取客户编号
export function queryByCusCode () {
  return http({
    url: '/api/customerBase/queryByCusCode',
    method: 'get'
  })
}
// 根据客户id查看客户详情
export function qeuryById (id) {
  return http({
    url: `/api/customerBase/queryById/${id}`,
    method: 'get'
  })
}
// 客户委托人
export function updateCustomerBase (data) {
  return http({
    url: '/api/customerBase/updateClientId        ',
    method: 'post',
    data: data
  })
}
// 修改客户信息
export function customeUpdate (data) {
  return http({
    url: '/api/customerBase/update        ',
    method: 'post',
    data: data
  })
}
// 修改联系人信息
export function updateCustomerConnect (data) {
  return http({
    url: '/api/customerConnect/update',
    method: 'post',
    data: data
  })
}
// 修改开票信息
export function updateCustomerInvoice (data) {
  return http({
    url: '/api/customerInvoice/update',
    method: 'post',
    data: data
  })
}
// 修改收货地址
export function updateCustomerRecevieInfo (data) {
  return http({
    url: '/api/customerRecevieInfo/update',
    method: 'post',
    data: data
  })
}
// 公共客户库-模糊查询
export function queryPageAllByPublic (page, size, data) {
  return http({
    url: `/api/customerBase/queryPageAllByPublic/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 公共客户库-批量导入权限
export function queryPublicBatch (page, size, data) {
  return http({
    url: '/api/SystemOpenController/queryPublicBatch',
    method: 'post',
    data: data
  })
}
// 根据联系人id删除联系人
export function customerConnectDelete (id) {
  return http({
    url: `/api/customerConnect/delete/${id}`,
    method: 'get'
  })
}
// 根据联系人id删除收货人/{id}
export function customerRecevieInfoDelete (id) {
  return http({
    url: `/api/customerRecevieInfo/delete/${id}`,
    method: 'get'
  })
}
// 设为主联系人
export function customerConnectUpdateByIsDefault (id, cbId) {
  return http({
    url: `/api/customerConnect/updateByIsDefault/${id}/${cbId}`,
    method: 'post'
  })
}
// 设为主收货人
export function customerRecevieInfoUpdateByIsDefault (id, cbId) {
  return http({
    url: `/api/customerRecevieInfo/updateByIsDefault/${id}/${cbId}`,
    method: 'post'
  })
}
// 提取客户
export function drawByCustomerId (id) {
  return http({
    url: `/api/customerBase/drawByCustomerId/${id}`,
    method: 'get'
  })
}
// 员工每月可提取数量
export function queryPubCount () {
  return http({
    url: '/api/customerSetting/queryPubCount',
    method: 'get'
  })
}
// 员工每月已提取数量
export function queryTransferCount () {
  return http({
    url: '/api/customerSetting/queryTransferCount',
    method: 'get'
  })
}
// 客户非批量 - 转移
export function transferByOwnId (data) {
  return http({
    url: '/api/customerBaseTransferApproval/teamTransferAdd',
    method: 'post',
    data: data
  })
}
// 客户批量 - 转移
export function BatchTransferByOwnId (data) {
  return http({
    url: '/api/customerBaseTransferApproval/teamBatchTransferAdd',
    method: 'post',
    data: data
  })
}
// 根据客户状态查询团队客户库列表
export function queryAllCustomerByOrgId (cusState, page, size, data) {
  return http({
    url: `/api/customerBase/queryAllCustomerByOrgId/${cusState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 客户资料库设置查看
export function querySetting () {
  return http({
    url: '/api/customerSetting/querySetting',
    method: 'get'
  })
}
// 修改客户资料库设置
export function customerSettingUpdate (data) {
  return http({
    url: '/api/customerSetting/update',
    method: 'post',
    data: data
  })
}
// 星级展示(根据星级水平排序)
export function settingStar () {
  return http({
    url: '/api/customerSettingStar/queryAll',
    method: 'get'
  })
}
// 添加星级
export function starAdd (num) {
  return http({
    url: `/api/customerSettingStar/add/${num}`,
    method: 'post'
    // params: {
    //   starPoint: num
    // }
  })
}
// 编辑星级
export function starUpdate (data) {
  return http({
    url: '/api/customerSettingStar/update',
    method: 'post',
    data: data
  })
}
// 删除星级
export function starDelete () {
  return http({
    url: '/api/customerSettingStar/delete',
    method: 'get'
  })
}
// 星级设置开关
export function settingStarUpdate (flag) {
  return http({
    url: `/api/customerSetting/updateByStart/${flag}`,
    method: 'post'
  })
}
// 星级提交
export function starSettlementUpdate (data) {
  return http({
    url: '/api/cutomerStarSettlement/update',
    method: 'post',
    data: data
  })
}
// 查看客户信用设置
export function settingCreditqueryAll (data) {
  return http({
    url: '/api/CustomerSettingCredit/queryAll',
    method: 'get'
  })
}
// 提交客户信用设置
export function settingCreditupdate (data) {
  return http({
    url: '/api/CustomerSettingCredit/update',
    method: 'post',
    data: data
  })
}
// 信用开关设置
export function updateByCredit (flag) {
  return http({
    url: `/api/customerSetting/updateByCredit/${flag}`,
    method: 'post'
  })
}
// 协议价模板管理列表禁用启用模糊查询
export function customerPriceTemplate (page, size, data) {
  return http({
    url: `/api/customerPriceTemplateList/queryAllSupplierBase/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 协议价模板管理列表模糊查询启用
export function cusPriTempListQueryAllByFlag (page, size, data) {
  return http({
    url: `/api/customerPriceTemplateList/queryAllByFlag/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 协议模板管理启用停用
export function templateUpdateByFlag (id, flag) {
  return http({
    url: `/api/customerPriceTemplateList/updateByFlag/${id}/${flag}`,
    method: 'post'
  })
}
// 客户协议模板启用停用
export function customerUpdateByFlag (data) {
  return http({
    url: '/api/customerPriceTemplateCustomer/updateByFlag',
    method: 'post',
    data: data
  })
}
// 协议价根据当前登录用户绑定模板客户信息
export function queryAllCustomerByLike (page, size, data) {
  return http({
    url: `/api/customerPriceTemplateBase/queryPageAllCustomer/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 协议价根据模板id和客户id绑定客户
export function customerTemplateAdd (id, data) {
  return http({
    url: `/api/customerPriceTemplateBase/add/${id}`,
    method: 'post',
    data: data
  })
}
// 协议价添加模板
export function customerPriceTemplateAdd (data) {
  return http({
    url: '/api/customerPriceTemplateList/add',
    method: 'post',
    data: data
  })
}
// 客户协议价添加模板
export function customerPriceNewTemplateAdd (templateName, data) {
  return http({
    url: `/api/customerPriceTemplateBase/addNew/${templateName}`,
    method: 'post',
    data: data
  })
}
// 协议价模板详情
export function queryEditById (id) {
  return http({
    url: `/api/customerPriceTemplateList/queryById/${id}`,
    method: 'get'
  })
}
// 根据协议价模板id修改协议价模板
export function updateTemplate (data) {
  return http({
    url: '/api/customerPriceTemplateList/update',
    method: 'post',
    data: data
  })
}
// 根据协议价模板id分页查询协议价品牌列表
export function priceBrandqueryPageAll (cpId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateContent/queryPageAllByBrand/${cpId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据协议价模板id分页查询协议价系列列表
export function priceSeriesqueryPageAll (cpId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateContent/queryPageAllBySeries/${cpId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据协议价模板id分页查询协议价产品列表
export function priceProductqueryPageAll (cpId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateContent/queryPageAllByProduct/${cpId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 添加协议价品牌-获取品牌下拉框
export function queryByCptIdBrand (cptId, data) {
  return http({
    url: `/api/brandBase/queryByCptIdBrand/${cptId}`,
    method: 'get',
    data: data
  })
}
// 添加协议价品牌
export function customerPriceBrSerProAdd (data) {
  return http({
    url: '/api/customerPriceTemplateContent/add',
    method: 'post',
    data: data
  })
}
// 添加客户协议价品牌,系列,产品
export function customerPriceTemplateCustomerAdd (cusId, data) {
  return http({
    url: `/api/customerPriceTemplateCustomer/add/${cusId}`,
    method: 'post',
    data: data
  })
}
// 停用启用协议价品牌/系列/产品
export function updateByFlagBrandSeriesProduct (data) {
  return http({
    url: '/api/customerPriceTemplateContent/updateByFlag',
    method: 'post',
    data: data
  })
}
// 修改协议品牌
export function customerPriceBraSerProUpdate (data) {
  return http({
    url: '/api/customerPriceTemplateContent/update',
    method: 'post',
    data: data
  })
}
// 修改客户协议品牌,系列,产品
export function customerPriceTemplateCustomerUpdate (data) {
  return http({
    url: '/api/customerPriceTemplateCustomer/update',
    method: 'post',
    data: data
  })
}
// 根据协议价模板id查看在用客户列表
export function queryAllCustomerPriceTemplate (id, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateBase/queryPageAllByProduct/${id}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 同步至模板
export function cusPriTemeCustomerUpdateByCpbId (cptId, cucId) {
  return http({
    url: `/api/customerPriceTemplateCustomer/updateByCpbId/${cptId}/${cucId}`,
    method: 'post'
  })
}
// 协议价模板批量更新
export function customerTemplateUpdate (data) {
  return http({
    url: '/api/customerPriceTemplateBase/updateByVersion',
    method: 'post',
    data: data
  })
}
// 协议价模板批量解绑
export function customerTemplateDelete (data) {
  return http({
    url: '/api/customerPriceTemplateBase/update',
    method: 'post',
    data: data
  })
}
// 根据id查看协议价模板信息
export function customerPriceTemplateBaseQueryById (id) {
  return http({
    url: `/api/customerPriceTemplateBase/queryById/${id}`,
    method: 'get'
  })
}
// 我的客户协议价品牌列表
export function queryPageAllByBrand (cusId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateCustomer/queryPageAllByBrand/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 我的客户协议价系列列表
export function queryPageAllBySeries (cusId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateCustomer/queryPageAllBySeries/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 我的客户协议价产品列表
export function queryPageAllByProduct (cusId, page, size, data) {
  return http({
    url: `/api/customerPriceTemplateCustomer/queryPageAllByProduct/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 客户详情特价审批记录
export function queryPageAllByCusId (cusId, page, size, data) {
  return http({
    url: `/api/customerSpecialPrice/queryPageAllByCusId/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 关闭特价-客户详情页
export function updateSpecialPriceByFlag (id) {
  return http({
    url: `/api/customerSpecialPrice/updateByFlag/${id}`,
    method: 'post'
  })
}
// 关闭特价-客户管理-特价审批列表
export function updateByFlagTow (id) {
  return http({
    url: `/api/customerSpecialPrice/updateByFlagTow/${id}`,
    method: 'post'
  })
}
// 根据权限查看特价审批列表
export function queryPageAllByPower (page, size, data) {
  return http({
    url: `api/customerSpecialPrice/queryPageAllByPower/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 星级展示(根据星级水平排序)
export function customerSettingStarQueryAll () {
  return http({
    url: '/api/customerSettingStar/queryAll',
    method: 'get'
  })
}
// 根据客户id星级调整
export function customerSettingStarUpdateByCusId (starId, cusId) {
  return http({
    url: `/api/customerSettingStar/updateByCusId/${starId}/${cusId}`,
    method: 'post'
  })
}
// 根据客户id和交易账户id修改交易账户信息
export function customerBankUpdate (data) {
  return http({
    url: '/api/customerBank/update',
    method: 'post',
    data: data
  })
}
// 设为主账号
export function customerBankUpdateByIsDefault (id, cusId) {
  return http({
    url: `/api/customerBank/updateByIsDefault/${id}/${cusId}`,
    method: 'post'
  })
}
// 删除交易账户
export function customerBankDelete (id) {
  return http({
    url: `/api/customerBank/delete/${id}`,
    method: 'post'
  })
}
// 客户调用
export function queryByOwnId (page, size, data) {
  return http({
    url: `/api/customerBase/queryByOwnId/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 客户调用
export function financialTransferCustomerInformation (page, size, data) {
  return http({
    url: `/api/customerBase/financialTransferCustomerInformation/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据客户is查看客户信用{cusId}
export function queryCustomerCreditById (cusId) {
  return http({
    url: `/api/customerBase/queryCustomerCreditById/${cusId}`,
    method: 'post'
  })
}
// 申请特价审批
export function customerSpecialPriceAdd (data) {
  return http({
    url: '/api/customerSpecialPrice/add',
    method: 'post',
    data: data
  })
}
// 根据客户id查看收货人
export function customerRecevieInfoQueryByCbId (cusId) {
  return http({
    url: `/api/customerRecevieInfo/queryByCbId/${cusId}`,
    method: 'get'
  })
}
// 根据客户id添加收货人
export function customerRecevieInfoAdd (data) {
  return http({
    url: '/api/customerRecevieInfo/add',
    method: 'post',
    data: data
  })
}
// 根据客户id划拨期初应收款
export function updateInitalByCusId (data) {
  return http({
    url: '/api/customerAccountBase/updateInitalByCusId/',
    method: 'post',
    data: data
  })
}
// 客户星级调整申请

export function customerStarApproval (data) {
  return http({
    url: '/api/customerStarApproval/add',
    method: 'post',
    data: data
  })
}
// 根据客户提额申请id查看客户提额申请审批详情
export function queryByCaaId (caaId) {
  return http({
    url: `/api/customerAmountApproval/queryByCaaId/${caaId}`,
    method: 'get'
  })
}
// 客户提额调整申请
export function customerAmountApproval (data) {
  return http({
    url: '/api/customerAmountApproval/add',
    method: 'post',
    data: data
  })
}
// 客户详情-合同清单
export function queryAllByCusId (cusId, page, size, state, data) {
  return http({
    url: `/api/orderContractBase/queryAllByCusId/${cusId}/${page}/${size}`,
    method: 'post',
    params: {
      state: state
    },
    data: data
  })
}
// 客户数据-合同清单-数据总览
export function queryAllCountByCusId (cusId) {
  return http({
    url: `/api/orderContractBase/queryAllCountByCusId/${cusId}`,
    method: 'post'
  })
}
// 委托客户列表
export function queryAllCustomerListByClientId (page, size, data) {
  return http({
    url: `/api/customerBase/queryAllCustomerListByClientId/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 客户划拨记录
export function queryAccountOrderByCusId (cusId, page, size) {
  return http({
    url: `/api/customerAccountBaseContent/queryAccountOrderByCusId/${cusId}/${page}/${size}`,
    method: 'post'
  })
}
// 客户划拨工单
export function queryAssignmentWorkOrderVo (cusId, page, size) {
  return http({
    url: `/api/customerAccountBaseContent/queryAssignmentWorkOrderVo/${cusId}/${page}/${size}`,
    method: 'post'
  })
}

// 根据客户id查看到款记录
export function queryFinanceAccountByCusId (cusId, page, size, data) {
  return http({
    url: `/api/customerAccountBaseContent/queryFinanceAccountByCusId/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 委托人
export function queryStaffBaseByClient (page, size, data) {
  return http({
    url: `/api/staffBase/queryStaffBaseByClient/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 客户变更(删除)委托人 /api/customerBaseAssignorApproval/add
export function customerBaseAssignorApproval (data) {
  return http({
    url: '/api/customerBaseAssignorApproval/add',
    method: 'post',
    data: data
  })
}
// 客户坏账记录

// 根据客户id查看到款记录
export function queryFinanceBadDebtListByCusId (cusId, page, size, data) {
  return http({
    url: `/api/financeBadDebt/queryFinanceBadDebtListByCusId/${cusId}/${page}/${size}`,
    method: 'get',
    data: data
  })
}
// 企业模糊查询接口

export function queryEnterQueryEinVo (pageNum, size, data) {
  return http({
    url: `/api/enterQueryTickerInfo/queryEnterQueryEinVo/${pageNum}/${size}`,
    method: 'post',
    data,
    time: 60000
  })
}

// 外部api验证码 验证
export function queryEnterQueryVerify (data) {
  return http({
    url: '/api/enterQueryTickerInfo/verify',
    method: 'post',
    data
  })
}

// 根据Id查询税号

export function queryEnterQueryEin (id) {
  return http({
    url: `/api/enterQueryTickerInfo/queryEnterQueryEin/${id}`,
    method: 'post'
  })
}
// 我的客户/客户关系转移
export function queryAllCustomerListByOwnId (cusState, type, page, size, data) {
  return http({
    url: `/api/customerBase/queryAllCustomerListByOwnId/${cusState}/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 客户管理设置
export function queryByClassCodeCRM (data) {
  return http({
    url: '/api/attrContent/queryByClassCodeCRM',
    method: 'post',
    data
  })
}

// 客户特价审批记录
export function queryPageByOwnIdAllPower (page, size, state, data) {
  return http({
    url: `/api/customerSpecialPrice/queryPageByOwnIdAllPower/${page}/${size}/${state}`,
    method: 'post',
    data: data
  })
}

// 客户看板 贸易额搜索
export function qureyCustomerMoney (cusId, data) {
  return http({
    url: `/api/customerBase/qureyCustomerMoney/${cusId}`,
    method: 'post',
    data: data
  })
}

// 客户详情-提现记录
export function queryByCusIdWithdrawal (cusId, page, size) {
  return http({
    url: `/api/financePay/queryByCusIdWithdrawal/${cusId}/${page}/${size}`,
    method: 'get'
  })
}

// 客户余额统计
export function queryCustomerAccountList (page, size, data) {
  return http({
    url: `/api/customerAccountBase/queryCustomerAccountList/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 客户余额统计-列表导出
export function exportCustomerAccountListXlsx (data) {
  return http({
    url: '/api/customerAccountBase/exportCustomerAccountListXlsx',
    method: 'get',
    responseType: 'blob',
    data: data
  })
}
